import React from "react";
import { Button, Modal } from "antd";
import "./modals.scss";
import AssetPreview from "common/components/AssetPreview";
import { MyFilesType } from "common/type";
import { downloadMyFileAssets } from "utils";

type propsType = {
  asset: MyFilesType | null;
  closePreview: () => void;
};

const ONE_GB = 1024 * 1024 * 1024;

const AssetPreviewModal = (props: propsType): React.ReactElement => {
  const { asset, closePreview } = props;
  const fileSize = Number(asset?.size);
  const isLargeFile = fileSize > ONE_GB;
  const isVideo = asset?.mimetype?.startsWith("video/");
  const shouldDisablePreview = isLargeFile && isVideo;

  return (
    <Modal
      open={!!asset}
      destroyOnClose={true}
      title={asset?.name}
      width="65%"
      wrapClassName="asset-preview-modal"
      onCancel={closePreview}
      footer={null}
    >
      <div className="inner-wrapper">
        {asset && shouldDisablePreview ? (
          <div className="download-only-wrapper">
            <p className="download-only-text">
              This file is larger than <strong>1GB</strong> and preview not available for large files. Please download the file.
            </p>
            <Button
              shape="round"
              type="primary"
              className="download-only-button"
              onClick={() => downloadMyFileAssets(asset?.url, asset?.name)}
            >
              Download File
            </Button>
          </div>
        ) : (
          asset && <AssetPreview asset={asset} />
        )}
      </div>
    </Modal>
  );
};

export default AssetPreviewModal;
